import {float, extract} from '../utils.js';
import {hashCode} from "utils/hashCode.js";
import {uuid} from 'uuidv4';
import {doc} from '../../docs.js';

doc(
    "sdf.softShadow",
    {
        "scene": "scene to compute soft shadow for",
        "rayOrigin" : "origin of ray",
        "rayDirection" : "direction of ray",
        "k" : "softness of shadow",
    },
    "Creates a soft shadow",
    () => 1,
    {
        inlets: 4
    }
);

export const sdf_soft_shadow = (object, rayOrigin, rayDirection, k) => {
    let id = uuid().replaceAll("-", "");
    return ([scene]) => {
        let {codes, uniforms, variables, functions} = extract(scene, rayOrigin, rayDirection, k);

        let functionName = "softShadow" + id;
        functions[functionName] = {
            args: {
                "ro": "vec3",
                "rd": "vec3",
                "k": "float",
            },
            returnType: "float",
            body: `
    float res = 1.0;
    float h = 0.0;
    float t = 0.1;
    for(int i = 0; i<50; i++) {
        vec2 di = ${scene.code('ro + rd*t')};
        h = di.x;
        if( h<0.001 )
            return 0.0;
        res = min( res, k*h/t );
        if(t>=200.0){
        	return res;
        }
        t+=h;
        
    }
    return res;
`
        };

        
        let code =`(${functionName}(${float(codes[1])}, ${float(codes[2])}, ${float(codes[3])}))`; 
        return [
            {
                code,
                variables,
                uniforms,
                functions,
                hashCode: hashCode(code)
            },
        ];
    };
};
